import type { CroppedImage } from '@sats-group/ui-lib/react/cropped-image/cropped-image.types';
import type { ValueOf } from 'type-fest';
import type { FocusArea } from '~/client/hooks/use-image-query';

export const themes = {
  rounded: 'rounded',
  round: 'round',
} as const;

export type DynamicImage = CroppedImage & {
  defaultHeight?: number;
  defaultWidth?: number;
  focusArea?: FocusArea;
  theme?: ValueOf<typeof themes>;
};
